import { gradientColorConvert as o } from "./index.es277.js";
const n = ({ layerType: e, value: r }) => {
  switch (e) {
    case "distance_in_miles":
      return `${r} mi`;
    case "choropleth":
    case "tta":
      return `${r}%`;
    case "dot_density":
      return `${r} visits`;
    case "vtv":
      return r;
    case "thematic":
      return r;
    case "tta_heat_map":
      return r;
    default:
      return `${r} min`;
  }
}, d = ({
  items: e,
  type: r
}) => {
  const t = e.map(({ value: a }) => a).join("/");
  return n({ layerType: r, value: t });
}, c = ({
  items: e,
  type: r,
  paletteColors: t
}) => r === "tta_heat_map" ? {
  layerColor: void 0,
  layerGradient: o(t)
} : e.length > 1 ? {
  layerColor: void 0,
  layerGradient: void 0
} : e.length === 1 ? {
  layerColor: e.map(({ color: a }) => a),
  layerGradient: void 0
} : {
  layerColor: void 0,
  layerGradient: void 0
};
export {
  n as getTTASuffix,
  c as getTradeAreaLayerColorIndicator,
  d as getTradeAreaLayerDescription
};
//# sourceMappingURL=index.es254.js.map
